import type { CashbackOfferListedAdminDto } from '@/backend/market'
import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CashbackOfferEntity } from '../../domain/entities/CashbackOfferEntity'

export class CashbackMiniModel extends CashbackOfferEntity {
  constructor(dataDto: CashbackOfferListedAdminDto) {
    super()
    mapEntityProperties<CashbackOfferEntity>(this, dataDto)
  }
}
